import {
  useDeployments,
  useDeploymentsForm,
} from "../../../hooks/deployments/useDeployments";
import {
  useEnforcementTeams,
  useEnforcementTeamsForm,
} from "../../../hooks/deployments/useEnforcementTeams";
import { API_DEPLOYMENTS, API_ENFORCEMENT_TEAMS } from "../../../utils/apis";

export const deploymentRegisterRoutes = {
  enforcement_teams: useEnforcementTeams,
  deployments: useDeployments,
};

export const deploymentFormRoutes = {
  enforcement_teams: useEnforcementTeamsForm,
  deployments: useDeploymentsForm,
};

export const deploymentApis = {
  enforcement_teams: API_ENFORCEMENT_TEAMS,
  deployments: API_DEPLOYMENTS,
};
